import React, { useState, useEffect, useCallback } from 'react';
import { collection, getDocs, getDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../hooks/useAuth';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { PRODUCT_TYPES, PILE_MODELS, FABRIC_TYPES, MECHANISM_TYPES, SYSTEM_TYPES, MOTOR_TYPES, REMOTE_TYPES, ACCESSORIES, DIRECTION_TYPES, DIKEY_DIRECTION_TYPES, MOUNTING_TYPES, TUL_PILE_MODELS, KANAT_PILE_MODELS, KATLAMALI_PERDE_MEKANIZMA_TIPLERI, JALUZI_SISTEM_TIPLERI } from '../../constants';
import { formatPrice, calculatePileDensity } from '../../utils';
import { sendSingleOrderWhatsAppMessage } from '../../utils/whatsappUtils';
import { handleNumericKeyDown, customSelectStyles } from './subcomponents/OrderFormUtils';
import OrderHeader from './subcomponents/OrderHeader';
import TulKanatForm from './subcomponents/productForms/TulKanatForm';
import StorZebraForm from './subcomponents/productForms/StorZebraForm';
import JaluziForm from './subcomponents/productForms/JaluziForm';
import DikeyForm from './subcomponents/productForms/DikeyForm';
import PliseForm from './subcomponents/productForms/PliseForm';
import RustikForm from './subcomponents/productForms/RustikForm';
import KatlamaliForm from './subcomponents/productForms/KatlamaliForm';
import AksesuarForm from './subcomponents/productForms/AksesuarForm';
import RaySistemiForm from './subcomponents/productForms/RaySistemiForm';
import OrderActions from './subcomponents/OrderActions';
import './OrderForm.css';

const OrderForm = ({
  isAddingOrder,
  editingOrderId,
  selectedProductType,
  newOrder,
  isLoading,
  customerInfo,
  customerId,
  onProductTypeChange,
  onFieldChange,
  onSubmit,
  onCancel,
  pileModels = [] // Pile modelleri prop olarak gelebilir (OrderDetails'dan)
}) => {
  const { user } = useAuth();
  const [selectedFirma, setSelectedFirma] = useState('');
  const [selectedFirmaKumas, setSelectedFirmaKumas] = useState('');
  const [selectedFirmaMekanizma, setSelectedFirmaMekanizma] = useState('');
  const [selectedFirmaMotor, setSelectedFirmaMotor] = useState('');
  const [selectedFirmaAksesuar, setSelectedFirmaAksesuar] = useState('');

  const [lastSentFirma, setLastSentFirma] = useState(null);
  const [lastSentFirmaKumas, setLastSentFirmaKumas] = useState(null);
  const [lastSentFirmaMekanizma, setLastSentFirmaMekanizma] = useState(null);
  const [lastSentFirmaMotor, setLastSentFirmaMotor] = useState(null);
  const [lastSentFirmaAksesuar, setLastSentFirmaAksesuar] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [localPileModels, setLocalPileModels] = useState([]);
  const [productItems, setProductItems] = useState([]);



  const [adminSettings, setAdminSettings] = useState({
    sPilePrice: 0, american2Price: 0, american3Price: 0,
    useManualRates: false, manualUsdRate: '', manualEurRate: '',
    ahsapJaluziMotorCurrency: 'USD', ahsapJaluziMotorPrice: '',
    metalJaluziMotorCurrency: 'USD', metalJaluziMotorPrice: '',
    storMotorCurrency: 'USD', storMotorPrice: '',
    zebraMotorCurrency: 'USD', zebraMotorPrice: '',
    dikeyPerdeMotorCurrency: 'USD', dikeyPerdeMotorPrice: '',
    dikeyPvcMotorCurrency: 'USD', dikeyPvcMotorPrice: '',
    dikeyStorMotorCurrency: 'USD', dikeyStorMotorPrice: '',
    katlamaliPerdeMotorCurrency: 'USD', katlamaliPerdeMotorPrice: '',
    zigilPrice: 0, reduktorPrice: 0, kurdelaPrice: 0,
    metalZigilPrice: 0, metalReduktorPrice: 0, ikiCamArasiPrice: 0,
    storJumboPrice: 0, storAltEtekDilimPrice: 0, storKapaliKasaPrice: 0,
    storAltEtekLazerPrice: 0, storDekoratifLamaPrice: 0, storDekoratifKasaPrice: 0,
    storAltEtekBeyazIsPrice: 0,
    zebraJumboPrice: 0, zebraAltEtekDilimPrice: 0, zebraKapaliKasaPrice: 0,
    dikeyFonPrice: 0, dikeyFonList: [],
    katlamaliMekanizmaList: [],
    rustikAyakModelList: [],
    rustikAyakCapList: [],
    rustikAyakUzunlukList: [],
    rustikAyakRenkKoduList: [],
    rustikAyakPrice: 0
  });
  const [exchangeRates, setExchangeRates] = useState({ USD: 1, EUR: 1 });

  // Ayarları ve Kurları Çek
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const settingsRef = doc(db, 'settings', 'global');
        const docSnap = await getDoc(settingsRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setAdminSettings({
            sPilePrice: Number(data.sPilePrice) || 0,
            american2Price: Number(data.american2Price) || 0,
            american3Price: Number(data.american3Price) || 0,
            useManualRates: data.useManualRates || false,
            manualUsdRate: data.manualUsdRate || '',
            manualEurRate: data.manualEurRate || '',
            ahsapJaluziMotorCurrency: data.ahsapJaluziMotorCurrency || 'USD',
            ahsapJaluziMotorPrice: data.ahsapJaluziMotorPrice || '',
            metalJaluziMotorCurrency: data.metalJaluziMotorCurrency || 'USD',
            metalJaluziMotorPrice: data.metalJaluziMotorPrice || '',
            storMotorCurrency: data.storMotorCurrency || 'USD',
            storMotorPrice: data.storMotorPrice || '',
            zebraMotorCurrency: data.zebraMotorCurrency || 'USD',
            zebraMotorPrice: data.zebraMotorPrice || '',
            dikeyPerdeMotorCurrency: data.dikeyPerdeMotorCurrency || 'USD',
            dikeyPerdeMotorPrice: data.dikeyPerdeMotorPrice || '',
            dikeyPvcMotorCurrency: data.dikeyPvcMotorCurrency || 'USD',
            dikeyPvcMotorPrice: data.dikeyPvcMotorPrice || '',
            dikeyStorMotorCurrency: data.dikeyStorMotorCurrency || 'USD',
            dikeyStorMotorPrice: data.dikeyStorMotorPrice || '',
            katlamaliPerdeMotorCurrency: data.katlamaliPerdeMotorCurrency || 'USD',
            katlamaliPerdeMotorPrice: data.katlamaliPerdeMotorPrice || '',
            zigilPrice: Number(data.zigilPrice) || 0,
            reduktorPrice: Number(data.reduktorPrice) || 0,
            kurdelaPrice: Number(data.kurdelaPrice) || 0,
            metalZigilPrice: Number(data.metalZigilPrice) || 0,
            metalReduktorPrice: Number(data.metalReduktorPrice) || 0,
            ikiCamArasiPrice: Number(data.ikiCamArasiPrice) || 0,
            storJumboPrice: Number(data.storJumboPrice) || 0,
            storAltEtekDilimPrice: Number(data.storAltEtekDilimPrice) || 0,
            storKapaliKasaPrice: Number(data.storKapaliKasaPrice) || 0,
            storAltEtekLazerPrice: Number(data.storAltEtekLazerPrice) || 0,
            storDekoratifLamaPrice: Number(data.storDekoratifLamaPrice) || 0,
            storDekoratifKasaPrice: Number(data.storDekoratifKasaPrice) || 0,
            storAltEtekBeyazIsPrice: Number(data.storAltEtekBeyazIsPrice) || 0,
            zebraJumboPrice: Number(data.zebraJumboPrice) || 0,
            zebraAltEtekDilimPrice: Number(data.zebraAltEtekDilimPrice) || 0,
            zebraKapaliKasaPrice: Number(data.zebraKapaliKasaPrice) || 0,
            dikeyFonPrice: Number(data.dikeyFonPrice) || 0,
            dikeyFonList: data.dikeyFonList || [],
            katlamaliMekanizmaList: data.katlamaliMekanizmaList || [],
            rustikAyakModelList: data.rustikAyakModelList || [],
            rustikAyakCapList: data.rustikAyakCapList || [],
            rustikAyakUzunlukList: data.rustikAyakUzunlukList || [],
            rustikAyakRenkKoduList: data.rustikAyakRenkKoduList || [],
            rustikAyakPrice: data.rustikAyakPrice || 0
          });
        }
      } catch (err) { }
    };

    const fetchRates = async () => {
      try {
        const res = await fetch('https://open.er-api.com/v6/latest/USD');
        const data = await res.json();
        if (data && data.rates && data.rates.TRY && data.rates.EUR) {
          const usdToTry = data.rates.TRY;
          const eurToTry = data.rates.TRY / data.rates.EUR;
          setExchangeRates({ USD: usdToTry.toFixed(2), EUR: eurToTry.toFixed(2) });
        }
      } catch (err) { }
    };

    fetchSettings();
    fetchRates();
  }, []);

  // Plise seçilince otomatik bir boş satır ekle (eğer liste boşsa)
  useEffect(() => {
    if (selectedProductType === 'plise' && (!newOrder.pliseItems || newOrder.pliseItems.length === 0)) {
      onFieldChange('pliseItems', [{ id: Date.now(), width: '', height: '', usedM2: '1.00', quantity: '', multisistem: false, rowTotal: '0.00' }]);
    }
  }, [selectedProductType, newOrder.pliseItems, onFieldChange]);

  // Motor Döviz Hesaplaması (Jaluzi, Stor, Zebra)
  useEffect(() => {
    const motorTypes = ['ahsapJaluzi', 'metalJaluzi', 'stor', 'zebra', 'dikeyPerde', 'dikeyPvc', 'dikeyStor', 'katlamaliPerde'];
    if (motorTypes.includes(selectedProductType) && newOrder.motorPriceCurrency !== undefined) {
      const currencyKey = `${selectedProductType}MotorCurrency`;
      const selectedCurrency = adminSettings[currencyKey] || 'USD';
      
      let rate = 1;
      if (adminSettings.useManualRates) {
        if (selectedCurrency === 'USD') rate = Number(adminSettings.manualUsdRate) || 1;
        else if (selectedCurrency === 'EUR') rate = Number(adminSettings.manualEurRate) || 1;
      } else {
        rate = exchangeRates[selectedCurrency] || 1;
      }

      const motorTL = Number(newOrder.motorPriceCurrency) * Number(rate);
      onFieldChange('motorPrice', motorTL);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newOrder.motorPriceCurrency, adminSettings, exchangeRates, selectedProductType]);

  const handleMotorTypeChange = (e) => {
    const val = e.target.value;
    onFieldChange('motorType', val);
    if (val && val !== '') {
      const priceKey = `${selectedProductType}MotorPrice`;
      const defaultPrice = adminSettings[priceKey];
      if (defaultPrice !== undefined && defaultPrice !== '') {
        onFieldChange('motorPriceCurrency', defaultPrice);
      }
    } else {
      onFieldChange('motorPriceCurrency', '');
      onFieldChange('motorPrice', 0);
    }
  };

  // Firmaları Firestore'dan çek
  useEffect(() => {
    const fetchCompanies = async () => {
      if (!user?.uid) {
        setCompanies([]);
        return;
      }

      try {
        // Artık userId bazlı filtreleme yok, tüm firmaları çek
        const companiesSnapshot = await getDocs(collection(db, 'companies'));
        const companiesList = companiesSnapshot.docs.map(doc => ({
          id: doc.id,
          name: doc.data().name,
          phone: doc.data().phone,
          defaultMessage: doc.data().defaultMessage || "Yeni sipariş bilgileri:"
        }));
        // İsme göre sırala
        companiesList.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        setCompanies(companiesList);
      } catch (error) {
        console.error('Firmalar yüklenirken hata:', error);
        setCompanies([]);
      }
    };

    fetchCompanies();
  }, [user]);

  // Pile modellerini sadece constants'tan al (Firestore'dan çekme)
  useEffect(() => {
    // Sadece constants'taki modelleri kullan
    const constantsModels = Object.entries(
      selectedProductType === 'tul' ? TUL_PILE_MODELS : KANAT_PILE_MODELS
    ).map(([key, modelName]) => ({
      id: `const_${key} `,
      modelName: modelName,
      density: calculatePileDensity(modelName)
    }));
    setLocalPileModels(constantsModels);
  }, [selectedProductType]);

  // Ürün Listesi'nden ürünleri çek (ürün tipine göre filtrele)
  const fetchProductItems = useCallback(async (productType) => {
    if (!productType) {
      setProductItems([]);
      return;
    }
    try {
      const snapshot = await getDocs(collection(db, 'productItems'));
      const all = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      const filtered = all
        .filter(p => {
          // katlamaliPerde için tül kumaşları kullanılır
          const targetType = productType === 'katlamaliPerde' ? 'tul' : productType;
          return p.productType === targetType;
        })
        .sort((a, b) => (a.name || '').localeCompare(b.name || '', 'tr'));
      setProductItems(filtered);
    } catch (error) {
      console.error('Ürün listesi yüklenirken hata:', error);
      setProductItems([]);
    }
  }, []);

  useEffect(() => {
    fetchProductItems(selectedProductType);
  }, [selectedProductType, fetchProductItems]);

  // Ürün seçilince adı ve birim fiyatı otomatik doldur
  const handleProductSelect = (productId) => {
    const product = productItems.find(p => p.id === productId);
    if (product) {
      onFieldChange('productName', product.name);

      // Eğer bir Jaluzi seçiliyse, unitPrice sistem tipine veya varsa ilk geçerli fiyata göre seçilmeli.
      let priceToSet = product.unitPrice;
      if (selectedProductType === 'ahsapJaluzi') {
        const pType = newOrder.sistemTipi;
        if (pType === JALUZI_SISTEM_TIPLERI.merdivenIpli) priceToSet = product.merdivenIpliFiyat || '';
        else if (pType === JALUZI_SISTEM_TIPLERI.kurdeleli) priceToSet = product.kurdeleliFiyat || '';
        else if (pType === JALUZI_SISTEM_TIPLERI.merdivenIpliReduktorlu) priceToSet = product.merdivenIpliReduktorluFiyat || '';
        else if (pType === JALUZI_SISTEM_TIPLERI.kurdelaliReduktorlu) priceToSet = product.kurdelaliReduktorluFiyat || '';
        else {
          // Sistem tipi henüz seçilmediyse, en mantıklı varsayılan fiyatı tablodan çek (kullanıcı tek fiyat girdiyse onu kullanır)
          priceToSet = product.merdivenIpliFiyat || product.kurdeleliFiyat || product.merdivenIpliReduktorluFiyat || product.kurdelaliReduktorluFiyat || '';
        }
      }

      let extra = 0;
      if (selectedProductType === 'tul' || selectedProductType === 'kanat') {
        if (newOrder.pileModel === 'S Pile') extra = adminSettings.sPilePrice;
        if (newOrder.pileModel === "Amerikan Pile 2'li") extra = adminSettings.american2Price;
        if (newOrder.pileModel === "Amerikan Pile 3'lü") extra = adminSettings.american3Price;
      } else if (selectedProductType === 'ahsapJaluzi') {
        if (newOrder.hasReduktor) extra += adminSettings.reduktorPrice;
        if (newOrder.hasKurdela) extra += adminSettings.kurdelaPrice;
      } else if (selectedProductType === 'metalJaluzi') {
        if (newOrder.hasMetalReduktor) extra += adminSettings.metalReduktorPrice;
      } else if (selectedProductType === 'dikeyPerde') {
        if (newOrder.hasDikeyFon) extra += adminSettings.dikeyFonPrice;
      } else if (selectedProductType === 'katlamaliPerde') {
        onFieldChange('fabricPrice', priceToSet);
      } else if (selectedProductType === 'rustik') {
        onFieldChange('ayakUcreti', adminSettings.rustikAyakPrice || 0);
      }
      // Maliyet hesaplama
      let costToSet = product.cost || 0;
      if (selectedProductType === 'ahsapJaluzi') {
        const pType = newOrder.sistemTipi;
        if (pType === JALUZI_SISTEM_TIPLERI.merdivenIpli) costToSet = product.merdivenIpliMaliyet || 0;
        else if (pType === JALUZI_SISTEM_TIPLERI.kurdeleli) costToSet = product.kurdeleliMaliyet || 0;
        else if (pType === JALUZI_SISTEM_TIPLERI.merdivenIpliReduktorlu) costToSet = product.merdivenIpliReduktorluMaliyet || 0;
        else if (pType === JALUZI_SISTEM_TIPLERI.kurdelaliReduktorlu) costToSet = product.kurdelaliReduktorluMaliyet || 0;
        else {
          costToSet = product.merdivenIpliMaliyet || product.kurdeleliMaliyet || product.merdivenIpliReduktorluMaliyet || product.kurdelaliReduktorluMaliyet || 0;
        }
      }
      onFieldChange('unitCost', costToSet);

      onFieldChange('unitPrice', Number(priceToSet) + extra);
      onFieldChange('baseUnitPrice', priceToSet);
    } else {
      onFieldChange('productName', '');
      onFieldChange('unitPrice', '');
    }
  };

  const handlePliseProduct1Select = (productId) => {
    const product = productItems.find(p => p.id === productId);
    if (product) {
      onFieldChange('pliseProduct1Name', product.name);
      onFieldChange('pliseProduct1Price', product.unitPrice || '');
    } else {
      onFieldChange('pliseProduct1Name', '');
      onFieldChange('pliseProduct1Price', '');
    }
  };

  const handlePliseProduct2Select = (productId) => {
    const product = productItems.find(p => p.id === productId);
    if (product) {
      onFieldChange('pliseProduct2Name', product.name);
      onFieldChange('pliseProduct2Price', product.unitPrice || '');
    } else {
      onFieldChange('pliseProduct2Name', '');
      onFieldChange('pliseProduct2Price', '');
    }
  };

  const handleKatlamaliMechanismSelect = (mechanismType) => {
    const mechanism = adminSettings.katlamaliMekanizmaList.find(m => m.type === mechanismType);
    if (mechanism) {
      onFieldChange('mechanismType', mechanism.type);
      onFieldChange('mechanismPrice', mechanism.price);
    } else {
      onFieldChange('mechanismType', mechanismType);
      onFieldChange('mechanismPrice', '');
    }
  };

  const handleAddAccessory = () => {
    const currentAccessories = Array.isArray(newOrder.accessories) ? newOrder.accessories : [];
    const newAccessories = [...currentAccessories, { id: Date.now().toString(), name: '', price: '', quantity: '1', total: '0' }];
    onFieldChange('accessories', newAccessories);
  };

  const handleRemoveAccessory = (id) => {
    const currentAccessories = Array.isArray(newOrder.accessories) ? newOrder.accessories : [];
    const newAccessories = currentAccessories.filter(acc => acc.id !== id);
    onFieldChange('accessories', newAccessories);
  };

  const handleAccessoryChange = (id, field, value) => {
    const currentAccessories = Array.isArray(newOrder.accessories) ? newOrder.accessories : [];
    const newAccessories = currentAccessories.map(acc => {
      if (acc.id === id) {
        let val = value;
        if (field === 'quantity') {
          const num = parseInt(value);
          if (!isNaN(num) && num < 1) val = '1';
          else if (value === '') val = ''; // allow empty during typing
        }
        const updatedAcc = { ...acc, [field]: val };
        if (field === 'price' || field === 'quantity') {
          const p = parseFloat(updatedAcc.price) || 0;
          const q = parseFloat(updatedAcc.quantity) || 0;
          updatedAcc.total = (p * q).toFixed(2);
        }
        return updatedAcc;
      }
      return acc;
    });
    onFieldChange('accessories', newAccessories);
  };

  const handleAddRayOption = () => {
    const currentOptions = Array.isArray(newOrder.rayOptions) ? newOrder.rayOptions : [];
    const newOptions = [...currentOptions, { id: Date.now().toString(), name: '', price: '', quantity: '1', total: '0' }];
    onFieldChange('rayOptions', newOptions);
  };

  const handleRemoveRayOption = (id) => {
    const currentOptions = Array.isArray(newOrder.rayOptions) ? newOrder.rayOptions : [];
    const newOptions = currentOptions.filter(opt => opt.id !== id);
    onFieldChange('rayOptions', newOptions);
  };

  const handleRayOptionChange = (id, field, value) => {
    const currentOptions = Array.isArray(newOrder.rayOptions) ? newOrder.rayOptions : [];
    const newOptions = currentOptions.map(opt => {
      if (opt.id === id) {
        const updatedOpt = { ...opt, [field]: value };
        if (field === 'price' || field === 'quantity') {
          const p = parseFloat(updatedOpt.price) || 0;
          const q = parseFloat(updatedOpt.quantity) || 0;
          updatedOpt.total = (p * q).toFixed(2);
        }
        return updatedOpt;
      }
      return opt;
    });
    onFieldChange('rayOptions', newOptions);
  };

  // Ürün için unique key oluştur
  const createProductKey = useCallback(() => {
    const { roomName, productName, productType } = newOrder;
    if (!roomName || !productName || !productType) return 'temp';

    // Oda + Ürün Adı + Ürün Tipi kombinasyonu ile unique key
    return `${productType} -${roomName} -${productName} `.replace(/[^a-zA-Z0-9-]/g, '').toLowerCase();
  }, [newOrder]);

  // Component mount olduğunda ve ürün bilgileri değiştiğinde localStorage'dan verileri yükle
  useEffect(() => {
    if (customerId && !customerId.startsWith('temp_')) {
      // Ürün bazında unique key oluştur
      const productKey = createProductKey();
      if (productKey !== 'temp') {
        const savedData = localStorage.getItem(`whatsapp - ${customerId} -${productKey} `);
        if (savedData) {
          try {
            const { selectedFirmaId, lastSentFirmaInfo } = JSON.parse(savedData);
            setSelectedFirma(selectedFirmaId || '');
            setLastSentFirma(lastSentFirmaInfo || null);
          } catch (error) {
            console.error('WhatsApp verileri yüklenirken hata:', error);
          }
        } else {
          // Bu ürün için kayıtlı veri yoksa sıfırla
          setSelectedFirma('');
          setLastSentFirma(null);
        }
      }
    }
  }, [customerId, createProductKey]);

  // WhatsApp gönderme fonksiyonu
  const handleWhatsAppSend = () => {
    if (!selectedFirma) {
      alert('Lütfen firma seçin!');
      return;
    }

    if (!customerInfo || !newOrder || !selectedProductType) {
      alert('Müşteri bilgileri veya sipariş bulunamadı!');
      return;
    }

    // Firestore'dan gelen firmaları kullan, yoksa constants'taki listeyi kullan
    const selectedFirmaInfo = companies.find(firma => firma.id === selectedFirma);
    if (selectedFirmaInfo) {
      // newOrder'a productType ekleyerek gönder
      const orderWithType = { ...newOrder, productType: selectedProductType };
      sendSingleOrderWhatsAppMessage(customerInfo, orderWithType, selectedFirmaInfo);

      // Son gönderilen firmayı kaydet
      setLastSentFirma(selectedFirmaInfo);

      // localStorage'a ürün bazında kaydet
      if (customerId && !customerId.startsWith('temp_')) {
        const productKey = createProductKey();
        const dataToSave = {
          selectedFirmaId: selectedFirma,
          lastSentFirmaInfo: selectedFirmaInfo
        };
        localStorage.setItem(`whatsapp - ${customerId} -${productKey} `, JSON.stringify(dataToSave));
      }
    }
  };

  // Katlamalı Perde için çoklu WhatsApp gönderme fonksiyonu
  const handleKatlamaliWhatsAppSend = (subType) => {
    let firmaId = '';
    if (subType === 'kumas') firmaId = selectedFirmaKumas;
    else if (subType === 'mekanizma') firmaId = selectedFirmaMekanizma;
    else if (subType === 'motor') firmaId = selectedFirmaMotor;
    else if (subType === 'aksesuar') firmaId = selectedFirmaAksesuar;

    if (!firmaId) {
      alert('Lütfen firma seçin!');
      return;
    }

    if (!customerInfo || !newOrder || !selectedProductType) {
      alert('Müşteri bilgileri veya sipariş bulunamadı!');
      return;
    }

    const selectedFirmaInfo = companies.find(firma => firma.id === firmaId);
    if (selectedFirmaInfo) {
      const orderWithType = { ...newOrder, productType: selectedProductType };
      sendSingleOrderWhatsAppMessage(customerInfo, orderWithType, selectedFirmaInfo, subType);

      // Son gönderilene kaydet
      if (subType === 'kumas') setLastSentFirmaKumas(selectedFirmaInfo);
      else if (subType === 'mekanizma') setLastSentFirmaMekanizma(selectedFirmaInfo);
      else if (subType === 'motor') setLastSentFirmaMotor(selectedFirmaInfo);
      else if (subType === 'aksesuar') setLastSentFirmaAksesuar(selectedFirmaInfo);
    }
  };



  // Ürün dropdown için ortak options objesi oluşturma
  const productOptions = productItems.map(p => ({ value: p.id, label: p.name }));

  return (
    <div className="order-form">
      <form onSubmit={onSubmit}>
        <OrderHeader
          selectedProductType={selectedProductType}
          setSelectedProductType={onProductTypeChange}
          isLoading={isLoading}
        />

        {selectedProductType && (
          <div className="dynamic-fields">
            {/* Tül ve Kanat için özel alanlar */}
            {(selectedProductType === 'tul' || selectedProductType === 'kanat') && (
              <TulKanatForm
                newOrder={newOrder}
                onFieldChange={onFieldChange}
                isLoading={isLoading}
                productItems={productItems}
                productOptions={productOptions}
                handleProductSelect={handleProductSelect}
                localPileModels={localPileModels}
                adminSettings={adminSettings}
                selectedProductType={selectedProductType}
              />
            )}

            {/* Stor ve Zebra için özel alanlar */}
            {(selectedProductType === 'stor' || selectedProductType === 'zebra') && (
              <StorZebraForm
                newOrder={newOrder}
                onFieldChange={onFieldChange}
                isLoading={isLoading}
                productItems={productItems}
                productOptions={productOptions}
                handleProductSelect={handleProductSelect}
                adminSettings={adminSettings}
                selectedProductType={selectedProductType}
                handleMotorTypeChange={handleMotorTypeChange}
              />
            )}

            {(selectedProductType === 'ahsapJaluzi' || selectedProductType === 'metalJaluzi') && (
              <JaluziForm
                newOrder={newOrder}
                onFieldChange={onFieldChange}
                isLoading={isLoading}
                productItems={productItems}
                productOptions={productOptions}
                handleProductSelect={handleProductSelect}
                adminSettings={adminSettings}
                selectedProductType={selectedProductType}
                handleMotorTypeChange={handleMotorTypeChange}
              />
            )}

            {(selectedProductType === 'dikeyPerde' || selectedProductType === 'dikeyPvc' || selectedProductType === 'dikeyStor') && (
              <DikeyForm
                newOrder={newOrder}
                onFieldChange={onFieldChange}
                isLoading={isLoading}
                productItems={productItems}
                productOptions={productOptions}
                handleProductSelect={handleProductSelect}
                adminSettings={adminSettings}
                selectedProductType={selectedProductType}
                handleMotorTypeChange={handleMotorTypeChange}
              />
            )}

            {selectedProductType === 'plise' && (
              <PliseForm
                newOrder={newOrder}
                onFieldChange={onFieldChange}
                isLoading={isLoading}
                productOptions={productOptions}
                handlePliseProduct1Select={handlePliseProduct1Select}
                handlePliseProduct2Select={handlePliseProduct2Select}
              />
            )}

            {selectedProductType === 'katlamaliPerde' && (
              <KatlamaliForm
                newOrder={newOrder}
                onFieldChange={onFieldChange}
                isLoading={isLoading}
                productItems={productItems}
                productOptions={productOptions}
                handleProductSelect={handleProductSelect}
                adminSettings={adminSettings}
                selectedProductType={selectedProductType}
                handleMotorTypeChange={handleMotorTypeChange}
                handleKatlamaliMechanismSelect={handleKatlamaliMechanismSelect}
                handleAddAccessory={handleAddAccessory}
                handleAccessoryChange={handleAccessoryChange}
                handleRemoveAccessory={handleRemoveAccessory}
              />
            )}

            {selectedProductType === 'aksesuar' && (
              <AksesuarForm
                newOrder={newOrder}
                onFieldChange={onFieldChange}
                isLoading={isLoading}
                productItems={productItems}
                productOptions={productOptions}
                handleProductSelect={handleProductSelect}
              />
            )}

            {selectedProductType === 'raySistemi' && (
              <RaySistemiForm
                newOrder={newOrder}
                onFieldChange={onFieldChange}
                isLoading={isLoading}
                productItems={productItems}
                productOptions={productOptions}
                handleProductSelect={handleProductSelect}
              />
            )}

            {selectedProductType === 'rustik' && (
              <RustikForm
                newOrder={newOrder}
                onFieldChange={onFieldChange}
                isLoading={isLoading}
                productItems={productItems}
                productOptions={productOptions}
                handleProductSelect={handleProductSelect}
                adminSettings={adminSettings}
                handleAddAccessory={handleAddAccessory}
                handleAccessoryChange={handleAccessoryChange}
                handleRemoveAccessory={handleRemoveAccessory}
                handleAddRayOption={handleAddRayOption}
                handleRayOptionChange={handleRayOptionChange}
                handleRemoveRayOption={handleRemoveRayOption}
              />
            )}

            <div className="form-group notes-field">
              <label>Not</label>
              <textarea
                value={newOrder.notes || ''}
                onChange={(e) => onFieldChange('notes', e.target.value)}
                rows="2"
                disabled={isLoading}
              />
            </div>
            </div>
          )}

          {selectedProductType && (
            <OrderActions
              isLoading={isLoading}
              selectedProductType={selectedProductType}
              onCancel={onCancel}
              newOrder={newOrder}
              companies={companies}
              selectedFirma={selectedFirma}
              setSelectedFirma={setSelectedFirma}
              lastSentFirma={lastSentFirma}
              selectedFirmaKumas={selectedFirmaKumas}
              setSelectedFirmaKumas={setSelectedFirmaKumas}
              lastSentFirmaKumas={lastSentFirmaKumas}
              selectedFirmaMekanizma={selectedFirmaMekanizma}
              setSelectedFirmaMekanizma={setSelectedFirmaMekanizma}
              lastSentFirmaMekanizma={lastSentFirmaMekanizma}
              selectedFirmaMotor={selectedFirmaMotor}
              setSelectedFirmaMotor={setSelectedFirmaMotor}
              lastSentFirmaMotor={lastSentFirmaMotor}
              selectedFirmaAksesuar={selectedFirmaAksesuar}
              setSelectedFirmaAksesuar={setSelectedFirmaAksesuar}
              lastSentFirmaAksesuar={lastSentFirmaAksesuar}
              handleWhatsAppSend={handleWhatsAppSend}
              handleKatlamaliWhatsAppSend={handleKatlamaliWhatsAppSend}
              customSelectStyles={customSelectStyles}
            />
          )}
      {!selectedProductType && (
        <div className="order-form-cancel" style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
          <button type="button" onClick={onCancel} className="cancel-btn">Vazgeç</button>
        </div>
      )}
    </form>
    </div>
  );
};

export default OrderForm; 